import { Graphics } from './graphics'
import { Color, YELLOW, GREEN, RED, WHITE, BLUE} from './color'
import { LineStyle, GREEN_LINE, RED_LINE, BLUE_LINE, WHITE_LINE, GRAY_LINE } from './lines'
import { Ship } from '../model/ship'
import { Point } from '../math/point'
import { vector, add, Vector } from '../math/vector'
import { Angle } from '../math/angle'
import { World } from '../model/world'
import { ShipDisplay } from './ship-display'
import { GridDisplay } from './grid-display'
import { hLineByMidpoint, vLineByMidpoint } from '../math/line'

const YELLOW_SLICE = YELLOW.setAlpha(0.25)
const RED_SLICE = RED.setAlpha(0.25)
const GREEN_SLICE = GREEN.setAlpha(0.25)
const WHITE_SLICE = WHITE.setAlpha(0.25)

export class TacticalDisplay {
  readonly shipDisplay: ShipDisplay
  // readonly gridDisplay: GridDisplay

  constructor(
    readonly graphics: Graphics) {
    this.shipDisplay = new ShipDisplay(graphics)
  //  this.gridDisplay = new GridDisplay(graphics)
  }

  drawFire(p: Point, ship: Ship) {
    this.graphics.lineStyle(RED_LINE)
    this.graphics.line(ship.position, p)
  }

  drawPhaser(p0: Point, p1: Point) {
    this.graphics.lineStyle(RED_LINE)

    this.graphics.line(p0, p1)
  }

  protected drawQuadrantArc(ship: Ship, target: Ship) {
    const shipQuadrant = ship.quadrant(target.position)
    this.shipDisplay.drawQuadrantArc(ship, shipQuadrant)
  }

drawCrosshair(ship: Ship, target: Ship) {
    const p0 = target.position
        // draw cursor highlight
        const hLine1 = hLineByMidpoint(new Point(p0.x, p0.y-5), 5)
        const hLine2 = hLineByMidpoint(new Point(p0.x, p0.y+5), 5)
        const vLine1 = vLineByMidpoint(new Point(p0.x-5, p0.y), 5)
        const vLine2 = vLineByMidpoint(new Point(p0.x+5, p0.y), 5)
        // const style = new LineStyle(new Color(0x99, 0x99, 0x99), 2)
        // this.graphics.lineStyle(style)
        this.graphics.drawLine(hLine1)
        this.graphics.drawLine(hLine2)
        this.graphics.drawLine(vLine1)
        this.graphics.drawLine(vLine2)

    // TODO: remove magic number
    // const shipRadius = 5
    // const a = 10
    // const b = 7
    // const v1a = new Vector(a,0)
    // const v1b = new Vector(b,0)
    // this.graphics.line(add(p, v1a), add(p, v1b))

    // const v2a = new Vector(-a,0)
    // const v2b = new Vector(-b,0)
    // this.graphics.line(add(p, v2a), add(p, v2b))

    // const v3a = new Vector(0,a)
    // const v3b = new Vector(0,b)
    // this.graphics.line(add(p, v3a), add(p, v3b))

    // const v4a = new Vector(0,-a)
    // const v4b = new Vector(0,-b)
    // this.graphics.line(add(p, v4a), add(p, v4b))
  }

  drawFireArc(ship: Ship, target: Ship) {
    // this.graphics.lineStyle(WHITE_LINE)
    // this.drawQuadrantArc(ship, target)

    this.graphics.lineStyle(RED_LINE)
    this.drawQuadrantArc(target, ship)
  }

  drawTargetArc(ship: Ship, target: Ship) {
    this.graphics.lineStyle(GRAY_LINE)

    this.drawQuadrantArc(ship, target)
    this.drawQuadrantArc(target, ship)
  }

  draw(world: World) {
    this.shipDisplay.draw(world.ship)
    world.enemies.forEach(e => this.shipDisplay.draw(e))
  }
}